const carouselCards = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20feature%20banner%20for%20a%20romantic%20Chinese%20drama%2C%20warm%20golden%20and%20rose%20tones%2C%20elegant%20silhouettes%2C%20soft%20dreamy%20atmosphere%2C%20premium%20editorial%20style%2C%20dramatic%20lighting%20with%20floral%20elements%2C%20clean%20composition&width=1200&height=600&seq=carousel-01-laozi&orientation=landscape',
    title: '玫瑰的故事：一场跨越二十年的女性成长',
    tag: '编辑精选',
    desc: '刘亦菲领衔主演，细腻刻画都市女性在不同人生阶段的选择与蜕变，38集完整上线。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20ancient%20Chinese%20detective%20drama%20feature%20banner%2C%20dark%20atmospheric%20tones%20with%20crimson%20accents%2C%20Tang%20dynasty%20aesthetic%2C%20mysterious%20shadowy%20figures%2C%20cinematic%20composition%2C%20dramatic%20contrast%20lighting&width=1200&height=600&seq=carousel-02-laozi&orientation=landscape',
    title: '唐朝诡事录之西行：诡案奇探再出发',
    tag: '口碑神作',
    desc: '卢凌风与苏无名原班人马回归，西域探案格局全面升级，悬疑烧脑程度翻倍。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Chinese%20drama%20feature%20banner%20with%20ethereal%20atmosphere%2C%20soft%20peach%20and%20gold%20tones%2C%20magical%20glowing%20elements%2C%20ancient%20mythological%20aesthetic%2C%20dreamy%20floating%20particles%2C%20romantic%20composition&width=1200&height=600&seq=carousel-03-laozi&orientation=landscape',
    title: '长相思第二季：上古情缘终章揭晓',
    tag: '全集上线',
    desc: '杨紫携全员回归，相思之苦终有答案，暑期档最受期待仙侠巨制全集放送。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20legal%20drama%20feature%20banner%2C%20sophisticated%20office%20setting%2C%20cool%20professional%20tones%2C%20Seoul%20cityscape%20background%2C%20dramatic%20contrast%2C%20clean%20editorial%20style%2C%20warm%20accent%20lighting&width=1200&height=600&seq=carousel-04-laozi&orientation=landscape',
    title: '好搭档：明星离婚律师的职场博弈',
    tag: '韩剧热播',
    desc: '张娜拉与南志铉双女主飙戏，职场与情感交织，韩国收视冠军同步更新。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20bright%20uplifting%20modern%20romance%20drama%20banner%2C%20warm%20sunlight%20tones%2C%20urban%20startup%20office%20setting%2C%20fresh%20youthful%20aesthetic%2C%20clean%20composition%2C%20soft%20bokeh%20background%2C%20positive%20energetic%20vibe&width=1200&height=600&seq=carousel-05-laozi&orientation=landscape',
    title: '你比星光美丽：科技创业里的浪漫相遇',
    tag: '热播中',
    desc: '谭松韵与许凯首次搭档，一个关于梦想、奋斗与爱情的都市治愈故事。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20fantasy%20Chinese%20animation%20style%20drama%20banner%2C%20dynamic%20action%20atmosphere%2C%20warm%20golden%20and%20crimson%20tones%2C%20traditional%20Chinese%20elements%2C%20youthful%20energy%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=1200&height=600&seq=carousel-06-laozi&orientation=landscape',
    title: '少年白马醉春风：国漫改编热血来袭',
    tag: '新番推荐',
    desc: '少年江湖热血冒险，国漫IP真人化精品之作，打戏与颜值双双在线。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          深度解读热门剧集，发现更多精彩
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselCards.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer hover:bg-white transition-colors duration-200"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} - 焦点专题`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <span className="absolute top-3 left-3 bg-accent-500 text-white text-xs px-2.5 py-1 rounded-full font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-150">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}